// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1EQPp","head":"Table_head__3KG0a","col":"Table_col__2vX9G"};